import React from "react";
import { useEffect, useState } from "react";
import Axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import { SnackbarProvider, useSnackbar } from "notistack";
import Navbar from "../../../components/Navbar";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Input from "../../../components/Input";
import SubmitButton from "../../../components/Button";
import style from "./CadastroNavio.module.css";
import MaskedInput from "../../../components/InputMask";

const CadastroNavio = () => {
  const navigate = useNavigate();

  const [nome, setNome] = useState("");
  const [imo, setImo] = useState("");
  const [bandeira, setBandeira] = useState("");
  const [tipoNavio, setTipoNavio] = useState("FERTILIZANTE");

  const usuario = JSON.parse(localStorage.getItem("user_token")).id;

  const [values, setValues] = useState({});
  function handleChange(event) {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  }

  const addNavio = () => {
    Axios.post("https://portal.jc7transportes.com.br/api/navio/criar", {
      nome: nome,
      imo: imo,
      bandeira: bandeira,
      status: "AGUARDANDO INÍCIO DA OPERAÇÃO",
      usuario: usuario,
    }).then(function (res) {
      console.log(res);
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Navio cadastrado com sucesso!", "success");
      setTimeout(() => {
        navigate("/navios");
      }, 2000);
    });
  };

  const { enqueueSnackbar } = useSnackbar();
  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  };

  const validaDados = () => {
    if (!nome) {
      showAlert("Preencha todos os campos!", "error");
      return;
    }
    addNavio();
  };

  return (
    <>
      <Navbar navios />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div className={style.navbar} onClick={() => navigate("/navios")}>
              Navios
            </div>
            <div className={style.active}>Cadastrar Navio</div>
          </div>

          <div className="columns">
            <div className="column is-4">
              <label className={style.label}>Tipo de Navio</label>
              <div className={style.radioGroup}>
                <label className={style.radio}>
                  <input
                    type="radio"
                    name="tipoNavio"
                    value="FERTILIZANTE"
                    checked={tipoNavio === "FERTILIZANTE"}
                    onChange={(e) => setTipoNavio(e.target.value)}
                  />
                  Fertilizante
                </label>
                <label className={style.radio}>
                  <input
                    type="radio"
                    name="tipoNavio"
                    value="CONTEINER"
                    checked={tipoNavio === "CONTEINER"}
                    onChange={(e) => setTipoNavio(e.target.value)}
                  />
                  Contêiner
                </label>
              </div>
            </div>

            <div className="column is-4">
              <Input
                type={"text"}
                text={"Nome do Navio"}
                onChange={(e) => [setNome(e.target.value.toUpperCase())]}
              />
            </div>
            <div className="column is-2">
              {tipoNavio === "FERTILIZANTE" && (
                <MaskedInput
                  text={"IMO"}
                  name={"IMO"}
                  mask={"99999999"}
                  value={values.Imo}
                  placeholder={"00000000"}
                  onChange={(e) => setImo(e.target.value.toUpperCase())}
                />
              )}
            </div>
          </div>

          <div className="columns">
            <div className="column is-5">
              <SubmitButton text={"Cadastrar"} onClick={validaDados} />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <CadastroNavio />
    </SnackbarProvider>
  );
}
